/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ streak: NonNullable<unknown> }} Wrapped_Share_StreakInputs */

const en_us2_wrapped_share_streak = /** @type {(inputs: Wrapped_Share_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.streak} training. My Pocket Gym.`)
};

const pt_br2_wrapped_share_streak = /** @type {(inputs: Wrapped_Share_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.streak} treinando. My Pocket Gym.`)
};

const es_419_wrapped_share_streak = /** @type {(inputs: Wrapped_Share_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.streak} entrenando. My Pocket Gym.`)
};

const pt_pt2_wrapped_share_streak = /** @type {(inputs: Wrapped_Share_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.streak} a treinar. My Pocket Gym.`)
};

const fr_fr2_wrapped_share_streak = /** @type {(inputs: Wrapped_Share_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.streak} à m'entraîner. My Pocket Gym.`)
};

const de_de2_wrapped_share_streak = /** @type {(inputs: Wrapped_Share_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.streak} im Training. My Pocket Gym.`)
};

const it_it2_wrapped_share_streak = /** @type {(inputs: Wrapped_Share_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.streak} ad allenarmi. My Pocket Gym.`)
};

/**
* | output |
* | --- |
* | "{streak} training. My Pocket Gym." |
*
* @param {Wrapped_Share_StreakInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_share_streak = /** @type {((inputs: Wrapped_Share_StreakInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Share_StreakInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_share_streak(inputs)
	if (locale === "es-419") return es_419_wrapped_share_streak(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_share_streak(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_share_streak(inputs)
	if (locale === "de-DE") return de_de2_wrapped_share_streak(inputs)
	if (locale === "it-IT") return it_it2_wrapped_share_streak(inputs)
	return en_us2_wrapped_share_streak(inputs)
});
export { wrapped_share_streak as "wrapped.share_streak" }